import React from 'react';
import Icon from '../../../../ui/icons/Icon';
import classes from './FinalWhatToExpectItem.module.css';

const FinalWhatToExpectItem = ({ icon, value, label }) => {
  
  return (
    <div className={classes.item}>
      <div className={classes.iconCircle}>
        <Icon name={icon} size={26} color="#292D32" />
      </div>
      <span className={classes.value}>{value}</span>
      <span className={classes.label}>{label}</span>
    </div>
  );
};

export default FinalWhatToExpectItem;
